import { render, staticRenderFns } from "./borderBoxView1.vue?vue&type=template&id=c83e54f2&"
import script from "./borderBoxView1.vue?vue&type=script&lang=js&"
export * from "./borderBoxView1.vue?vue&type=script&lang=js&"
import style0 from "./borderBoxView1.vue?vue&type=style&index=0&id=c83e54f2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports